/* eslint-disable */
import Vue from 'vue'
import login from '../views/login.vue'
import dashboard from '../views/dashboard.vue'
import profile from '../views/profile.vue'
import profileUpdated from '../views/profile-updated.vue'
import accountBalance from '../views/account-balance.vue'
import greenCredit from '../views/green-credit.vue'
import Locale from '../locale/locale.js'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'

// const { Vue, VueRouter } = window
Vue.use(VueRouter)
Vue.use(VueHead)

const routes = [
  {
    path: '*',
    beforeEnter: (to, from, next) => {
      next('/en/')
    }
  },
  {
    path: '/:lang',
    component: login
  },
  {
    path: '/:lang/dashboard',
    component: dashboard
  },
  {
    path: '/:lang/profile',
    component: profile
  },
  {
    path: '/:lang/profile-updated',
    component: profileUpdated
  },
  {
    path: '/:lang/account-balance',
    component: accountBalance
  },
  {
    path: '/:lang/green-credit',
    component: greenCredit
  }
]

const router = new VueRouter({
  routes
})
export default router

router.beforeEach((to, from, next) => {
  const locale = to.params.lang

  if (!locale) {
    return next()
  }

  Vue.use({
    install (Vue) {
      Vue.prototype.$LOCALE = locale
      Vue.prototype.$LANG = Locale[locale]
    }
  })
  next()
})

// window.NAV = new Vue({
//   name: 'Nav',
//   el: '#nav',
//   data: {
//     menuToggle: false,
//     lang: 'en'
//   },

//   mounted () {
//     const currentUrl = window.location.href
//     if (currentUrl.indexOf('/bm/') >= 0) {
//       this.lang = 'bm'
//     }
//   },

//   methods: {
//     changeLocale (lang) {
//       const currentUrl = window.location.href
//       const splittedPath = currentUrl.split('/')
//       // staging/production lang config
//       // if (splittedPath[5] !== lang) {
//       // local lang config
//       // if (splittedPath[4] !== lang) {
//       if (splittedPath[5] !== lang) {
//         const remUrlPos = currentUrl.indexOf(this.lang)
//         const remUrl = currentUrl.substr(remUrlPos + 2)
//         const startUrl = currentUrl.substr(0, remUrlPos)
//         window.location = startUrl + lang + remUrl
//       }
//     },

//     redirect (url) {
//       const currUrl = window.location.href.split('/')
//       let baseURL = currUrl[2]
//       const newLoc = 'https://' + baseURL + '/' + this.lang + '/' + url
//       window.location = newLoc
//     },

//     toggleMenu () {
//       if (this.menuToggle === false) {
//         document.getElementById('mobile-nav').classList.add('active-m')
//         this.menuToggle = true
//       } else {
//         document.getElementById('mobile-nav').classList.remove('active-m')
//         this.menuToggle = false
//       }
//     }
//   },
//   router,
//   scrollBehavior (to, from, savedPosition) {
//     return { x: 0, y: 0 }
//   }
// })

// window.FOOT = new Vue({
//   name: 'Footer',
//   el: '#footer',
//   data: {
//     lang: 'en'
//   },
//   router,
//   mounted () {
//     document.querySelector('#app-container').classList.add('active')

//     const currentUrl = window.location.href
//     if (currentUrl.indexOf('/bm/') >= 0) {
//       this.lang = 'bm'
//     }
//   },
//   scrollBehavior (to, from, savedPosition) {
//     return { x: 0, y: 0 }
//   },

//   methods: {
//     changeLocale (lang) {
//       const currentUrl = window.location.href
//       const splittedPath = currentUrl.split('/')
//       // staging/production lang config
//       // if (splittedPath[5] !== lang) {
//       // local lang config
//       // if (splittedPath[4] !== lang) {
//       if (splittedPath[5] !== lang) {
//         const remUrlPos = currentUrl.indexOf(this.lang)
//         const remUrl = currentUrl.substr(remUrlPos + 2)
//         const startUrl = currentUrl.substr(0, remUrlPos)
//         window.location = startUrl + lang + remUrl
//       }
//     },

//     redirect (url) {
//       const currUrl = window.location.href.split('/')
//       let baseURL = currUrl[2]
//       const newLoc = 'https://' + baseURL + '/' + this.lang + '/' + url
//       window.location = newLoc
//     }
//   }
// })

// window.APP = new Vue({
//   name: 'Main',
//   el: '#main',
//   router,
//   scrollBehavior (to, from, savedPosition) {
//     return { x: 0, y: 0 }
//   },
//   watch: {
//     $route (to, from) {
//       if (to.params.lang !== from.params.lang) {
//         // eslint-disable-next-line
//         location.reload()
//       }
//     }
//   }
// })
